<template>
  <StyledDiv>
    <StyledDiv height="200px" :backgroundColor="styled('pdfPink')">
      <StyledText
        padding="0 15px"
        :fontSize="styled('fontSize-mediumLarge')"
        :fontFamily="styled('fontFamily-GothamMedium')"
        :smallTabletFontSize="styled('fontSize-medium')"
        :mobileFontSize="styled('fontSize-mediumSmall')"
        >let's build something great together</StyledText
      >
    </StyledDiv>
  </StyledDiv>
</template>

<script>
import { StyledDiv, StyledText } from "../styled";
import StyleCompiler from "../styled/StyleCompiler";
export default {
  components: {
    StyledDiv,
    StyledText
  },
  methods: {
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style></style>
